import { useCallback, useRef, useState } from "react";
import ProjectLeftPanel from "./ProjectLeftPanel";
import ProjectRightPanel from "./ProjectRightPanel";

const MIN_LEFT_WIDTH = 220;
const MAX_LEFT_WIDTH = 480;

export default function ManageProjectLayout({
  project,
  selectedStageId,
  activeTab,
  loading,
  isAdmin,
  onSelectStage,
  onTabChange,
  onAllocate,
  onRemoveAllocation,
  onAssignStage,
  onReassign,
  onReschedule,
  onRemove,
  onReview,
}) {
  const [leftWidth, setLeftWidth] = useState(260);
  const draggingRef = useRef(false);
  const containerRef = useRef(null);

  const handleDragMove = useCallback((e) => {
    if (!draggingRef.current || !containerRef.current) return;
    const containerLeft = containerRef.current.getBoundingClientRect().left;
    const nextWidth = Math.min(
      MAX_LEFT_WIDTH,
      Math.max(MIN_LEFT_WIDTH, e.clientX - containerLeft),
    );
    setLeftWidth(nextWidth);
  }, []);

  const handleDragEnd = useCallback(() => {
    draggingRef.current = false;
    document.body.style.cursor = "";
    document.body.style.userSelect = "";
    document.removeEventListener("mousemove", handleDragMove);
    document.removeEventListener("mouseup", handleDragEnd);
  }, [handleDragMove]);

  const handleDragStart = useCallback(
    (e) => {
      e.preventDefault();
      draggingRef.current = true;
      document.body.style.cursor = "col-resize";
      document.body.style.userSelect = "none";
      document.addEventListener("mousemove", handleDragMove);
      document.addEventListener("mouseup", handleDragEnd);
    },
    [handleDragMove, handleDragEnd],
  );

  return (
    <div className="manage-project-layout" ref={containerRef}>
      <ProjectLeftPanel
        project={project}
        selectedStageId={selectedStageId}
        onSelectStage={onSelectStage}
        onAllocate={onAllocate}
        onRemoveAllocation={onRemoveAllocation}
        loading={loading}
        isAdmin={isAdmin}
        width={leftWidth}
      />
      <div
        className="panel-resize-handle"
        onMouseDown={handleDragStart}
        role="separator"
        aria-orientation="vertical"
        aria-label="Resize stages panel"
      />
      <ProjectRightPanel
        project={project}
        selectedStageId={selectedStageId}
        activeTab={activeTab}
        onTabChange={onTabChange}
        onAssignStage={onAssignStage}
        onReassign={onReassign}
        onReschedule={onReschedule}
        onRemove={onRemove}
        onReview={onReview}
        loading={loading}
        isAdmin={isAdmin}
      />
    </div>
  );
}
